import store_laboratoire from '@/store/mods/analyses/laboratoire'
import { duree_lisible, mois_courant, libelle_mois } from '@/utils/laboratoire-delais'

// LAB-008 : indicateurs mensuels du laboratoire (délais depuis les jalons, volumes, rejets, non-conformités, valeurs critiques).
const message = (error, fallback) => error && error.response && error.response.data && typeof error.response.data.message === 'string' ? error.response.data.message : fallback

export default {
    name: 'indicateurs-laboratoire',
    components: {},
    // LAB-UI-2 : integre = dans la carte du circuit ; LAB-UI-3 : kpi = cartes KPI en tête du tableau, sans carte englobante
    props: { integre: { type: Boolean, default: false }, kpi: { type: Boolean, default: false } },
    data() {
        return {
            mois: mois_courant(), indicateurs: null, is_loading: false, erreur: '', requete: 0, detruit: false
        }
    },

    watch: {

    },

    computed: {
        libelle_mois() {
            return libelle_mois(this.mois)
        },

        // Tuiles affichées (mêmes données en carte, intégrée ou KPI)
        tuiles() {
            const i = this.indicateurs
            if (!i || !i.disponible) return []
            const pct = (i.rendu_dans_cible_pct === null || i.rendu_dans_cible_pct === undefined) ? '—' : i.rendu_dans_cible_pct + ' %'
            const alerte = n => (Number(n) > 0 ? 'indicateur-alerte' : '')
            const stat = (s, unite) => 'moyen ' + this.duree(s.moyenne_min) + ' · max ' + this.duree(s.max_min) + ' · ' + s.nombre + ' ' + unite
            const tuiles = [
                { cle: 'validees', libelle: 'Analyses validées', valeur: i.validees, detail: 'dont ' + i.urgentes_validees + ' urgente(s)', classe: '', titre: 'Lignes validées et diffusées dans le mois' },
                { cle: 'acheminement', libelle: 'Délai d\'acheminement (médian)', valeur: this.duree(i.acheminement.mediane_min), detail: stat(i.acheminement, 'mesure(s)'), classe: '', titre: 'Prélèvement → réception au laboratoire' },
                { cle: 'rendu', libelle: 'Délai de rendu (médian)', valeur: this.duree(i.rendu.mediane_min), detail: stat(i.rendu, 'mesure(s)'), classe: '', titre: 'Réception → validation biologique' }
            ]
            // LAB-009 : performance du laboratoire — technique par analyse, demande du médecin → résultats disponibles
            if (i.technique) tuiles.push({ cle: 'technique', libelle: 'Technique par analyse (médiane)', valeur: this.duree(i.technique.mediane_min), detail: stat(i.technique, 'analyse(s)'), classe: '', titre: 'Début → fin de la technique, analyses terminées dans le mois' })
            if (i.demande_resultats) tuiles.push({ cle: 'demande_resultats', libelle: 'Demande → résultats (médian)', valeur: this.duree(i.demande_resultats.mediane_min), detail: stat(i.demande_resultats, 'analyse(s)'), classe: '', titre: 'Demande du médecin → validation biologique, analyses validées dans le mois' })
            const toutes = tuiles.concat([
                { cle: 'cible', libelle: 'Rendus dans le délai cible', valeur: pct, detail: 'cible ' + this.cible('rendu_heures') + ' h', classe: this.classe_cible, titre: 'Part des résultats validés dans le délai cible' },
                { cle: 'recues', libelle: 'Reçues', valeur: i.recues, detail: i.saisies + ' saisie(s) · ' + i.en_cours + ' en cours', classe: '', titre: 'Lignes reçues dans le mois' },
                { cle: 'rejets', libelle: 'Rejets d\'échantillons', valeur: i.rejets, detail: 'nouveau prélèvement demandé', classe: alerte(i.rejets), titre: 'Échantillons rejetés à la réception' },
                { cle: 'non_conformites', libelle: 'Non-conformités déclarées', valeur: i.non_conformites, detail: 'voir le registre', classe: alerte(i.non_conformites), titre: 'Registre des non-conformités' },
                { cle: 'critiques', libelle: 'Valeurs critiques', valeur: i.valeurs_critiques, detail: i.rectifications + ' rectification(s)', classe: alerte(i.valeurs_critiques), titre: 'Valeurs critiques signalées et rectifications' }
            ])
            if (!this.kpi) return toutes
            const delai = i.demande_resultats ? 'demande_resultats' : 'rendu'
            return ['validees', delai, 'cible', 'critiques'].map(cle => toutes.find(tuile => tuile.cle === cle))
        },

        classe_cible() {
            if (!this.indicateurs || this.indicateurs.rendu_dans_cible_pct === null || this.indicateurs.rendu_dans_cible_pct === undefined) return ''
            return this.indicateurs.rendu_dans_cible_pct >= 90 ? 'indicateur-ok' : 'indicateur-alerte'
        }
    },

    mounted() {
        this.charger()
    },

    beforeDestroy() {
        this.detruit = true
        this.requete++
    },

    methods: {
        charger() {
            if (this.detruit) return Promise.resolve()
            const requete = ++this.requete
            this.is_loading = true
            this.erreur = ''
            return store_laboratoire.getIndicateurs(this.mois).then((response) => {
                if (this.detruit || requete !== this.requete) return
                if (!response || !response.success || !response.data) throw new Error('Réponse invalide')
                this.indicateurs = response.data
                this.is_loading = false
            }).catch((error) => {
                if (this.detruit || requete !== this.requete) return
                this.indicateurs = null
                this.is_loading = false
                this.erreur = message(error, 'Impossible de charger les indicateurs. Réessayez avec Actualiser.')
            })
        },

        duree(minutes) {
            return duree_lisible(minutes)
        },

        cible(cle) {
            const cibles = this.indicateurs && this.indicateurs.cibles ? this.indicateurs.cibles : { acheminement_heures: 2, rendu_heures: 24 }
            return cibles[cle] !== undefined ? cibles[cle] : '—'
        }
    }
}
